// extracted by mini-css-extract-plugin
module.exports = {"cookieConsent":"cookieConsent--2BMP3","buttonRow":"buttonRow--14Wpc","acceptButton":"acceptButton--2GzU_","customizeButton":"customizeButton--1Jf2f"};